<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">{{
                  notaTomador ? 'Consulta e gerenciamento das Notas Fiscais de Serviço Tomadas.' :
                    'Consulta e gerenciamento dos Documentos Auxiliares de Prestação de Serviço (DAPS) emitidos.'
                }}</span>
                <br />
                <span class="navigation">{{ notaTomador ? 'Nota Tomador > Consulta' : 'DAPS > Consulta' }}</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <error-list :erros="erros" />
          <consulta-declaracoes-nota-fiscal />
          <cancelar-nota-fiscal />
          <enviar-email-daps />

          <div class="row">
            <div class="col-md-3 col-lg-2 mb-3">
              <span class="p-fluid">
                <Dropdown id="tipoEmissao" name="tipoEmissao" @change="pesquisar()" v-model="selectedTipoDaps"
                  :options="tiposDaps" optionLabel="name" placeholder="Tipo Emissão" @keyup.enter="pesquisar" />
              </span>
            </div>
            <div class="col-md-3 col-lg-1 mb-3">
              <span class="p-fluid">
                <InputText type="text" id="filtroNumero" v-model="filtroNumero" placeholder="Número" autocomplete="off"
                  @keyup.enter="pesquisar" />
              </span>
            </div>
            <div class="col-md-3 col-lg-2 mb-3">
              <span class="p-fluid">
                <Calendar id="dataIni" name="dataFim" v-model="dataFatoGeradorIni" :showIcon="true"
                  dateFormat="dd/mm/yy" placeholder="Data Inicial" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
              </span>
            </div>
            <div class="col-md-3 col-lg-2 mb-3">
              <span class="p-fluid">
                <Calendar id="dataFim" name="dataFim" v-model="dataFatoGeradorFim" :showIcon="true"
                  dateFormat="dd/mm/yy" placeholder="Data Final" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
              </span>
            </div>
            <div class="col-md-12 col-lg-3 mb-3">
              <!-- <span class="p-fluid">
                <AutoComplete
                    id="tomador"
                    v-model="selectedPessoa"
                    :dropdown="true"
                    :suggestions="filteredPessoas"
                    @complete="searchPessoa($event)"
                    field="detail"
                    :placeholder="nomeFiltro"
                    @keyup.enter="pesquisar"
                  />
                </span>-->
              <span class="p-fluid">
                <InputText type="text" id="filtro" v-model="filtro" :placeholder="nomeFiltro" autocomplete="off" />
              </span>
            </div>
            <div class="col-md-3 col-lg-2 mb-2">
              <span class="p-fluid">
                <Dropdown id="situacao" v-model="filtroSituacao" :options="filtroSituacoes" optionLabel="name"
                  placeholder="Selecione uma Situação" />
              </span>
            </div>
            <div class="col-md-6 mb-2 d-flex" v-if="exibirFiltroIntermediario">
              <Checkbox id="binary" v-model="filtroPesquisarIntermediario" :binary="true" />
              <label class="ml-2" for="binary">Pesquisar como Intermediário?</label>
            </div>
          </div>
          <div class="mb-2">
            <Button @click="pesquisar()" label="Pesquisar" type="button" class="p-button-primary mr-2"
              icon="pi pi-search" :disabled="loading" />
            <!--
            <SplitButton
              @click="imprimirConsultaDAPS()"
              label="Imprimir"
              icon="pi pi-print"
              :model="menuImpressao"
              title="Imprimir"
              :disabled="loading"
            />
            -->
            <Button class="btn btn-primary mr-2" type="button" id="dropdownMenuButton" icon="pi pi-angle-down"
              label="Imprimir" data-toggle="dropdown" title="Imprimir" aria-haspopup="true" aria-expanded="false"
              :disabled="loading"></Button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <button class="dropdown-item" type="button" :disabled="loading" @click="imprimirPdf()">
                <span class="pi pi-print mr-2"></span>{{ notaTomador ? 'Relação de Notas Tomador' : 'Relação de DAPS' }}
              </button>
              <button class="dropdown-item" type="button" :disabled="loading" @click="imprimirLivroFiscalTomados()">
                <span class="pi pi-print mr-2"></span>Livro Fiscal Serviços Tomados
              </button>
            </div>
            <Button @click="downloadListagemXml()" label="Exportar Notas Fiscais" type="button"
              class="p-button-primary mr-2" icon="pi pi-download" :disabled="loading" />
          </div>

          <hr />

          <div class="row pr-3 pl-3">
            <DataTable :value="dapsList" :paginator="true" :rows="10" :autoLayout="true" ref="dt">
              <template #empty>
                Nenhum resultado encontrado.
              </template>
              <Column headerStyle="width: 4.2em">
                <template #body="slotProps">
                  <div class="dropdown">
                    <Button class="btn btn-primary" type="button" icon="pi pi-angle-down" id="dropdownMenuButton"
                      title="Opções" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></Button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <button v-if="exibirCampoNfsa(slotProps.data.tipo, slotProps.data.situacao)" class="dropdown-item"
                        type="button" :disabled="loading"
                        @click="visualizar(slotProps.data.tipo, slotProps.data.id)"><span
                          class="pi pi-search mr-2"></span>Visualizar</button>
                      <button v-if="exibirCampoNfsa(slotProps.data.tipo, slotProps.data.situacao)" class="dropdown-item"
                        type="button" :disabled="loading"
                        @click="download(slotProps.data.tipo, slotProps.data.id)"><span
                          class="pi pi-download mr-2"></span>Download</button>
                      <div class="dropdown-divider" />
                      <button class="dropdown-item" type="button"
                        v-if="slotProps.data.situacao != 'Cancelada' && slotProps.data.tipo === 'D'"
                        :disabled="loading || inativo" @click="cancelarDaps(slotProps.data.id)"><span
                          class="pi pi-times mr-2"></span>Cancelar</button>
                      <button class="dropdown-item" type="button" v-if="slotProps.data.tipo === 'N'" :disabled="loading"
                        @click="downloadXml(slotProps.data.id)">
                        <span class="pi pi-download mr-2"></span>Exportar XML
                      </button>
                      <button class="dropdown-item" type="button" :disabled="loading" v-if="slotProps.data.tipo === 'D'"
                        @click="visualizarAnexo(slotProps.data.id)">
                        <span class="pi pi-envelope mr-2"></span>Anexo
                      </button>
                      <button class="dropdown-item" type="button" :disabled="loading ||
                        slotProps.data.situacao == 'Cancelada' ||
                        slotProps.data.situacao == 'Substituída'
                        " v-show="slotProps.data.tipo === 'D'"
                        @click="enviarEmail(slotProps.data.id)">
                        <span class="pi pi-envelope mr-2"></span>Enviar por
                        E-mail
                      </button>
                      <div class="dropdown-divider" />
                      <button class="dropdown-item" type="button" :disabled="loading" v-show="exibirConsultaDeclaracao"
                        @click="consultaDeclaracoesDaps(slotProps.data.tipo, slotProps.data.id)">
                        <span class="pi pi-file-o mr-2"></span>Consulta de Declarações
                      </button>
                      <button class="dropdown-item" type="button" :disabled="loading"
                        v-if="slotProps.data.tipo === 'D' && slotProps.data.motivoRecusaDaps != null && slotProps.data.motivoRecusaDaps"
                        v-show="exibirConsultaDeclaracao" @click="consultaMotivoRecusa(slotProps.data.id)">
                        <span class="pi pi-file-o mr-2"></span>Visualizar Motivo de Recusa
                      </button>
                      <div class="dropdown-divider" />
                      <button class="dropdown-item" type="button" :disabled="loading"
                        v-if="slotProps.data.tipo === 'D' && slotProps.data.motivoRecusaDaps"
                        @click="detailDaps(slotProps.data.id)">
                        <span class="pi pi-plus mr-2"></span>Refazer Daps
                      </button>
                      <button class="dropdown-item" type="button"
                        v-if="slotProps.data.tipo === 'N' && slotProps.data.deferimentoAceite === 'S'"
                        :disabled="loading"
                        @click="exibirTelaDeferimento(slotProps.data.id, slotProps.data.documentoTomador)">
                        <span class="pi pi-check mr-2"></span>Aceite Deferimento
                      </button>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="tipoDescricao" header="Tipo" bodyStyle="text-align:center" headerStyle="width: 10em"
                v-if="!notaTomador">
              </Column>
              <Column field="tipoDescricaoNotaTomador" header="Tipo" bodyStyle="text-align:center" v-if="notaTomador">
              </Column>
              <Column field="numeroNota" header="Número" bodyStyle="text-align:right"></Column>
              <Column field="competenciaFormatada" header="Competência" bodyStyle="text-align:center"></Column>
              <Column field="dataGeracaoFormatada" header="Geração" bodyStyle="text-align:center"></Column>
              <Column headerStyle="min-width: 10em" field="valorFormatado" header="Valor" bodyStyle="text-align:right">
              </Column>
              <Column headerStyle="min-width: 15em" field="dadosPrestador" header="Prestador"
                v-if="this.selectedTipoDaps.key != 'P'">
              </Column>
              <Column headerStyle="min-width: 15em" field="dadosTomador" header="Tomador"
                v-if="this.selectedTipoDaps.key != 'T' && this.selectedTipoDaps.key != 'E'"></Column>
              <Column field="situacao" header="Situação" bodyStyle="text-align:center"></Column>
              <template #footer>
                <div style="text-align: right">
                  <Button icon="pi pi-external-link" label="Exportar para CSV" @click="imprimirExcel()" />
                </div>
              </template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
    <Dialog header="Motivo de Recusa" :visible.sync="showMotivoRecusa" :modal="true" :closable="false">
      <h1 class="titulo-header">
        Motivo de Recusa
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showMotivoRecusa = false" />
      </h1><br />
      <div class="container scrolable-dialog">
        <div id="topo" class="row">
          <DataTable :value="motivoRecusaList" :paginator="true" :rows="5" class="p-datatable-responsive"
            :autoLayout="true">
            <Column field="motivoRecusaDaps" header="Motivo Recusa"></Column>
          </DataTable>
        </div>
      </div>

      <hr />

      <div class="container">
        <div class="row">
          <div>
            <Button @click="ocultarDialogRecusaDaps()" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Anexo" :visible.sync="displayAnexos" :style="{ width: '35vw' }" :modal="true">
      <h1 class="titulo-header">
        Anexo
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayAnexos = false" />
      </h1><br />
      <DataTable :value="anexosDaps" :paginator="true" :rows="10" :autoLayout="true" style="min-width: 100%">
        <template #empty>Nenhum anexo encontrado.</template>
        <Column headerStyle="width: 2.5em" header bodyStyle="text-align: center">
          <template #body="slotProps">
            <Button type="button" title="Download" class="p-button-primary mr-2" icon="pi pi-download"
              style="margin-right: 0.5em" @click="
                downloadArquivo(
                  slotProps.data.id,
                  slotProps.data.tipoArquivo,
                  slotProps.data.nomeArquivo,
                )
                " :disabled="loading"></Button>
          </template>
        </Column>
        <Column field="nomeArquivo" header="Arquivo" bodyStyle="text-align:right"></Column>
      </DataTable>
      <hr/>
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="displayAnexos = false" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Deferimento Cancelamento Nota Fiscal" :visible.sync="showDeferimento" :style="{ width: '50vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Deferimento Cancelamento Nota Fiscal
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showDeferimento = false" />
      </h1><br />
      <DataTable :value="deferimentos" :paginator="true" :rows="4" :autoLayout="true" style="min-width: 100%">
        <Column>
          <template #body="slotProps">
            <Button label="Aceitar Cancelamento" style="margin-right: .5em" icon="pi pi-check"
              @click="cancelarNotaFiscal(slotProps.data)"
              :disabled="slotProps.data.status === 'N' || slotProps.data.status === 'A'" />
            <Button class="p-button-danger" label="Negar Cancelamento" icon="pi pi-times"
              @click="negarCancelamentoNota(slotProps.data)"
              :disabled="slotProps.data.status === 'N' || slotProps.data.status === 'A'" />
          </template>
        </Column>
        <Column field="notaFiscal.numero" header="Número Nota" bodyStyle="text-align:center"></Column>
        <Column field="statusFormatado" header="Status" bodyStyle="text-align:left"></Column>
      </DataTable>
      <hr/>
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="ocultarTelaDeferimento()" class="p-button-danger" />
          </div>
        </div>
      </div>

    </Dialog>
  </div>
</template>
<script>
import { maska } from 'maska'
import DapsService from "../services/nfse/daps.service";
import ReportService from "../services/report.service";
import money from "../conf/config.money";
import LoginService from "../services/acesso/login.service";
import NfsPessoaService from "../services/nfse/pessoa.service";
import ConsultaDeclaracoesNotaFiscal from '../components/emissaoNfse/ConsultaDeclaracoesNotaFiscal';
import CancelarNotaFiscal from "../components/emissaoNfse/CancelarNotaFiscal";
import EnviarEmailDaps from "../components/emissaoNfse/EnviarEmailDaps";
import AceiteCancelamentoService from '../services/nfse/aceite.cancelamento.service';
import NotaFiscalService from "@/services/nfse/notafiscal.service";

export default {
  components: { ConsultaDeclaracoesNotaFiscal, CancelarNotaFiscal, EnviarEmailDaps },
  props: {
    notaTomador: Boolean
  },
  directives: { maska },
  name: "ConsultaDaps",
  data() {
    return {
      money: money,
      inativo: false,
      display: false,
      loading: false,
      filtro: "",
      filtroNumero: "",
      filtroSituacao: "",
      filtroSituacoes: [
        { name: "Todos", key: "T" },
        { name: "Ativa", key: "A" },
        { name: "Cancelada", key: "C" },
        { name: "Substituída", key: "S" },
        { name: "Retido Na Fonte", key: "R" },
        { name: "Recusada", key: "E" }
      ],
      erros: [],
      dapsList: [],
      dapsId: null,
      currentUser: null,
      observacaoClienteNfse: false,
      filteredPessoas: null,
      selectedPessoa: null,
      dataFatoGeradorIni: null,
      dataFatoGeradorFim: null,
      selectedTipoDaps: null,
      selectedIdDaps: null,
      anexosDaps: [],
      displayAnexos: false,
      exibirConsultaDeclaracao: true,
      exibirMotivoRecusa: false,
      showMotivoRecusa: false,
      motivoRecusaList: [],
      dapsSelecionada: null,
      filtroPesquisarIntermediario: false,
      deferimentos: [],
      notaFiscal: [],
      showDeferimento: false,
      tiposDaps: [
        { name: "Todos", key: "A" },
        { name: (this.notaTomador ? "Serviços Prestados" : "DAPS Prestados"), key: "P" },
        { name: (this.notaTomador ? "Serviços Tomados" : "DAPS Tomados"), key: "T" },
        { name: "Notas Fiscais Eletrônicas Tomadas", key: "E" }
      ],
      menuImpressao: [
        {
          label: (this.notaTomador ? 'Relação de Notas Tomador' : 'Relação de DAPS'),
          icon: 'pi pi-print',
          disabled: this.loading,
          command: () => {
            this.imprimirPdf();
          }
        },
        {
          label: 'Livro Fiscal Serviços Tomados',
          icon: 'pi pi-print',
          disabled: this.loading,
          command: () => {
            this.imprimirLivroFiscalTomados();
          }
        }
      ],
      statusAceite: true
    };
  },

  mounted() {
    document.getElementById("filtroNumero").focus();
  },

  created() {
    this.currentUser = LoginService.currentUserValue;
    this.dataFatoGeradorIni = new Date();
    this.dataFatoGeradorIni.setDate(this.dataFatoGeradorIni.getDate() - 60);
    this.dataFatoGeradorFim = new Date();
    if (this.currentUser.configuracao && this.currentUser.configuracao.idBolModeloFechamento === 'E') {
      this.exibirConsultaDeclaracao = false;
    }
    this.inativo = (this.currentUser && this.currentUser.contribuinte ? !this.currentUser.contribuinte.ativo : false);
    this.selectedTipoDaps = this.tiposDaps[0];
    this.selectedPessoa = "";
    this.observacaoClienteNfse = this.currentUser.configuracao.idBolObservacaoNfse === "S";
    this.pesquisar();
  },

  methods: {
    pesquisar() {
      this.erros = []
      this.processando(true);

      if (!this.dataFatoGeradorIni) {
        this.$root.$emit("alert:warn", "Data Inicial Obrigatório para consulta!");
        return;
      }
      if (!this.dataFatoGeradorFim) {
        this.$root.$emit("alert:warn", "Data Final Obrigatório para consulta!");
        return;
      }
      /*if (this.selectedPessoa && this.selectedPessoa.documento){
        this.filtro = this.selectedPessoa.documento;
      } else {
        this.filtro = "";
      }*/

      DapsService.listAllFiltroPesquisar(
        this.filtro,
        this.filtroNumero,
        this.dataFatoGeradorIni,
        this.dataFatoGeradorFim,
        this.selectedTipoDaps.key,
        (this.filtroSituacao ? this.filtroSituacao.key : "T"),
        this.filtroPesquisarIntermediario
      )
        .then(response => {
          this.dapsList = response;
          console.log(this.dapsList);
        })
        .then(() => {
          this.processando(false);
        });
    },

    consultaDeclaracoesDaps(tipo, id) {
      if (tipo && id) {
        this.$root.$emit("daps:consultaDeclaracoes", tipo, id);
      }
    },

    consultaMotivoRecusa(daps) {
      this.showMotivoRecusa = true;
      this.dapsSelecionada = daps;
      DapsService.listMotivoRecusaDaps(
        daps
      ).then(
        response => {
          this.motivoRecusaList = response.data;
          console.log(response);
          console.log(this.motivoRecusaList);
        },
        error => {
          let errorMessage = "Houve um problema ao listar as Declarações!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        });
    },

    consultaDeferimento() {
      AceiteCancelamentoService.findNotasNegadas(
        this.documentoTomador,
        this.idNota
      ).then(
        aceite => {
          this.deferimentos = aceite.data;
          this.deferimentos.forEach(deferimento => {
            const nota = deferimento.notaFiscal;
            this.notaFiscal = nota;
          });

        },
        error => {
          let errorMessage = "Houve um problema ao listar a nota para deferimento!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },

    exibirTelaDeferimento(idNota, documento) {
      this.showDeferimento = true;
      this.idNota = idNota;
      this.documentoTomador = documento;
      this.consultaDeferimento();
    },

    ocultarTelaDeferimento() {
      this.showDeferimento = false;
    },

    exibirCampoNfsa(tipo, situacao) {
      if (tipo === "NA") {
        if (situacao.includes("Paga")) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },

    cancelarNotaFiscal(deferimentoNota) {
      if (deferimentoNota) {
        NotaFiscalService.aceiteCancelamento(
          deferimentoNota.notaFiscal.id,
          deferimentoNota.id,
          deferimentoNota.observacaoNota
        )
          .then(
            (data) => {
              console.log(data);
              this.$root.$emit("alert:success", "Nota Fiscal Cancelada Com Sucesso!");
              this.showDeferimento = false;
              this.pesquisar();
            },
            (error) => {
              this.$parent.erros.push(...error.response.data);
              console.log(error.response);
            }
          )
      }
    },

    negarCancelamentoNota(deferimentoNota) {
      if (deferimentoNota) {
        NotaFiscalService.negarCancelamento(
          deferimentoNota.notaFiscal.id,
          deferimentoNota.id
        )
          .then(
            (data) => {
              console.log(data);
              this.$toast.add({
                severity: "success",
                summary: "Cancelamento da Nota Fiscal Foi Negado!",
                life: 2500
              });
              this.consultaDeferimento();
            },
            (error) => {
              let errorMessage = "Houve um erro negar o cancelamento da Nota Fiscal!";
              if (error.response) {
                errorMessage = error.response.data;
              }
              this.$toast.add({
                severity: "error",
                summary: errorMessage,
                life: 3000
              });
            }
          )
      }
    },

    detailDaps(id) {
      this.$router.push({ name: "emissaoDaps", params: { idDaps: id } });
    },

    searchPessoa(event) {
      setTimeout(async () => {
        this.filteredPessoas = await NfsPessoaService.findAllByConttribuinteFiltroDaps(
          event.query,
          "",
          ""
        );
      }, 250);
    },

    ocultarDialogRecusaDaps() {
      this.showMotivoRecusa = false;
    },

    imprimirPdf() {
      this.imprimirConsultaDAPS('pdf');
    },

    imprimirExcel() {
      this.imprimirConsultaDAPS('xls');
    },

    imprimirConsultaDAPS(tipo) {
      var msg = null;
      if (!this.currentUser.contribuinte.documento) {
        msg = "É necessário informar o contribuinte!";
      }
      else if (!this.dataFatoGeradorIni) {
        msg = "É necessário informar a data Inicial!";
      }
      else if (!this.dataFatoGeradorFim) {
        msg = "É necessário informar a data Final!";
      }
      /*if (this.selectedPessoa && this.selectedPessoa.documento){
        this.filtro = this.selectedPessoa.documento;
      } else {
        this.filtro = null;
      }*/
      if (!msg) {
        this.processando(true);
        ReportService.imprimir((tipo == 'pdf' ? "ConsultaDaps" : "ConsultaDapsXls"), [
          {
            param: "ID_CLIENTE",
            string: this.currentUser.usuario.idCliente
          },
          {
            param: "DOC_CONTRIBUINTE",
            string: this.currentUser.contribuinte.documento
          },
          {
            param: "FILTRO",
            string: this.filtro
          },
          {
            param: "TIPO_DAPS",
            string: this.selectedTipoDaps.key
          },
          {
            param: "NUMERO",
            string: this.filtroNumero
          },
          {
            param: "DATA_INICIAL",
            date: this.dataFatoGeradorIni
          },
          {
            param: "DATA_FINAL",
            date: this.dataFatoGeradorFim
          },
          {
            param: "NOTA_TOMADOR",
            string: this.notaTomador ? 'S' : 'N'
          },
          {
            param: "P_SITUACAO",
            string: (this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : 'T'),
          },
        ], tipo)
          .then(
            () => { },
            error => {
              this.$root.$emit("alert:warn", "Erro ao Imprimir!");
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
      else {
        this.$root.$emit("alert:warn", msg);
      }
    },

    imprimirLivroFiscalTomados() {
      var msg = null;
      if (!this.currentUser.contribuinte.documento) {
        msg = "É necessário informar o contribuinte!";
      }
      else if (!this.dataFatoGeradorIni) {
        msg = "É necessário informar a data Inicial!";
      }
      else if (!this.dataFatoGeradorFim) {
        msg = "É necessário informar a data Final!";
      }

      if (!msg) {
        this.processando(true);
        ReportService.imprimir("LivroFiscalServicosTomados", [
          {
            param: "ID_CLIENTE",
            string: this.currentUser.usuario.idCliente
          },
          {
            param: "DOCUMENTO_PRESTADOR",
            string: this.currentUser.contribuinte.documento
          },
          {
            param: "DATA_INICIAL",
            date: this.dataFatoGeradorIni
          },
          {
            param: "DATA_FINAL",
            date: this.dataFatoGeradorFim
          },
          {
            param: "NOME_PRESTADOR",
            string: this.currentUser.contribuinte.nome
          },
          {
            param: "NOME_EMPRESA",
            string: this.currentUser.usuario.nomeCliente
          },
          {
            param: "P_SITUACAO",
            string: (this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : null),
          }
        ])
          .then(
            () => { },
            error => {
              this.$root.$emit("alert:warn", "Erro ao Imprimir!");
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
      else {
        this.$root.$emit("alert:warn", msg);
      }
    },

    visualizar(tipo, id) {
      this.processando(true);

      let nomeRel = (tipo === 'D' ? (this.notaTomador ? 'NotaFiscalTomador' : 'NotaFiscalAuxiliar') : (this.observacaoClienteNfse ? "NotaFiscalEletronicaObs" : "NotaFiscalEletronica"));
      let where = tipo === 'D' ? " and nota.id = '" + id + "'" : " and nota_fiscal.id = '" + id + "'";
      ReportService.imprimir(nomeRel, [
        {
          param: "where",
          string: where
        }
      ])
        .then(
          () => { },
          error => {
            this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },

    download(tipo, id) {
      this.processando(true);

      let nomeRel = (tipo === 'D' ? (this.notaTomador ? 'NotaFiscalTomador' : 'NotaFiscalAuxiliar') : (this.observacaoClienteNfse ? "NotaFiscalEletronicaObs" : "NotaFiscalEletronica"));
      let where = tipo === 'D' ? " and nota.id = '" + id + "'" : " and nota_fiscal.id = '" + id + "'";

      ReportService.download(nomeRel, [
        {
          param: "where",
          string: where
        }
      ])
        .then(
          () => { },
          error => {
            this.$root.$emit("alert:warn", "Erro ao efetuar o download!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },

    downloadXml(nfseId) {
      this.processando(true);

      ReportService.downloadXml(nfseId)
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao efetuar o download!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },

    cancelarDaps(idDaps) {
      this.processando(true);
      console.log(idDaps);
      this.erros = [];
      DapsService.cancelar(idDaps)
        .then(
          data => {
            console.log(data);
            this.$toast.add({
              severity: "success",
              summary: "Sucesso",
              detail: "O DAPS foi Cancelado!",
              life: 4000
            });
            this.pesquisar();
          },
          error => {
            this.erros.push(...error.response.data);
            console.log(error.response);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },

    detail(dapsId) {
      this.$router.push({ name: "emissaoDaps", params: { id: dapsId } });
    },
    visualizarAnexo(id) {
      this.processando(true);
      this.anexosDaps = [];
      DapsService.carregarAnexosDaps(
        id
      ).then((response) => {
        this.anexosDaps = response.data;
        this.displayAnexos = true;
      }).then(() => {
        this.processando(false);
      });
    },
    downloadArquivo(id, type, nome) {
      this.processando(true);
      DapsService.downloadAnexo(
        id, type, nome
      ).then(
        (data) => {
          console.log(data);
        },
        (error) => {
          this.$root.$emit("alert:warn", "Erro ao efetuar o download!");
          console.log(error);
        }
      )
        .then(() => {
          this.processando(false);
        });
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },

    downloadListagemXml() {
      var msg = null;
      if (!this.currentUser.contribuinte.idContribuinte) {
        msg = "É necessário informar o contribuinte!";
      } else if (!this.dataFatoGeradorIni) {
        msg = "É necessário informar a data Inicial!";
      } else if (!this.dataFatoGeradorFim) {
        msg = "É necessário informar a data Final!";
      } else if (!this.filtroSituacao && !this.filtroSituacao.key) {
        msg = "É necessário informar uma Situação!"
      }

      if (!msg) {
        this.processando(true);
        ReportService.downloadListXmlTomador(
          this.currentUser.contribuinte.idContribuinte,
          this.dataFatoGeradorIni,
          this.dataFatoGeradorFim,
          (this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : null),
          this.$root
        )
          .then(
            (data) => {
              console.log(data);
            },
            (error) => {
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit("alert:warn", msg);
      }
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    enviarEmail(id) {
      if (id) {
        this.$root.$emit("daps:enviarEmail", id);
      }
    },
  },

  computed: {
    nomeFiltro: {
      get() {
        return (
          "CPF/CNPJ/Nome" +
          (this.selectedTipoDaps.key == "A" ? "" : (this.selectedTipoDaps.key == "T" ? " Prestador" : " Tomador"))
        );
      }
    },

    exibirFiltroIntermediario: {
      get() {
        return (this.currentUser.configuracao.idBolIntermediario === "S");
      }
    }
  }
};
</script>

<style src="../assets/css/consultaDaps.css"></style>
